<script>
export const pageName = 'membership-buy-card';
export const pageRoute = '/membership/buy-a-card';
export const title = 'Buy a membership card'
export const requireMembership = true;
export const requireCompleteAccount = true;

export default {
	data() {
		return {
		}
	}
}

</script>
<template>
	<div  class="container py-5">
		<div class="row">
			<div class="col col-6">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Option 1</h4>
					</div>
					<div class="card-body text-center">
						<span class="display-2">£10.00</span>
						<p class="mb-4">Membership card only</p>
						<a href="/membership/buy-a-card/checkout?type=card" class="btn btn-primary">Buy card only <span class="fe fe-arrow-right-circle"></span></a>
					</div>
				</div>
			</div>
			<div class="col col-6">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Option 2</h4>
						<span class="badge badge-success p-2"><span class="fe fe-tag"></span> Special Offer</span>
					</div>
					<div class="card-body text-center">
						<span class="display-2">£10.00</span>
						<p class="mb-4">Includes a UKRA branded lanyard and card holder.</p>
						<a href="/membership/buy-a-card/checkout?type=card_lanyard" class="btn btn-primary">Buy card with lanyard and holder <span class="fe fe-arrow-right-circle"></span></a>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
